import React from 'react';

import PropTypes from 'prop-types';

import MaskedInput from 'react-text-mask';

const PhoneInput = ({ value, name, placeholder, onChange, required }) => (
  <MaskedInput
    mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    guide
    placeholder={placeholder}
    name={name}
    value={value}
    onChange={(e) => onChange(e, e.target.value)}
    required={required}
  />
);

export default PhoneInput;

PhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

PhoneInput.defaultProps = {
  onChange: () => null,
  placeholder: '(123) 456-7890',
  value: '',
  required: false,
};
